import React, { useState } from 'react';
import PowerPlantRegistration from './PowerPlantRegistration';
import UserRegistration from './UserRegistration';
import EquipmentRequestRegistration from './EquipmentRequestRegistration';
import UserPowerPlantConnection from './UserPowerPlantConnection';
import PolicyRegistration from './PolicyRegistration';
import './RegistrationPage.css';

const RegistrationPage = ({ user, onLogout }) => {
  const [activeTab, setActiveTab] = useState('powerplant');

  const tabs = [
    { id: 'powerplant', label: '발전소 등록', icon: '🏭' },
    { id: 'user', label: '사용자 등록', icon: '👤' },
    { id: 'equipment', label: '장비 설정 승인', icon: '⚙️' },
    { id: 'connection', label: '사용자-발전소 연결', icon: '🔗' },
    { id: 'policy', label: '정책', icon: '📄' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'powerplant':
        return <PowerPlantRegistration />;
      case 'user':
        return <UserRegistration />;
      case 'equipment':
        return <EquipmentRequestRegistration />;
      case 'connection':
        return <UserPowerPlantConnection />;
      case 'policy':
        return <PolicyRegistration />;
      default:
        return <PowerPlantRegistration />;
    }
  };

  return (
    <div className="registration-page">
      <div className="registration-page-layout">
        <nav className="registration-sidebar" aria-label="등록 메뉴">
          {tabs.map(tab => (
            <button
              key={tab.id}
              type="button"
              className={`sidebar-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </nav>

        <div className="registration-main">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;
